module.exports = __webpack_public_path__ + "static/media/WW-Portfolio_Website_Pages-09-sm.6dd05503.jpg";